import { metrics } from '@seek/metrics-js';

import { getUnconfirmedRolesFromCache } from 'src/components/Profile/CareerHistory/data';
import { CreateResumeActions } from 'src/components/Profile/CreateResume/reducer';
import { getUnconfirmedQualificationsFromCache } from 'src/components/Profile/Education/data';
import type { AppConfig } from 'src/modules/appConfig/types';
import type { Action, ApiClient } from 'src/types';

import { ProfileActions } from './analytics/profile/profile.ts';

export const createMetricsMiddleware =
  (
    { apolloClient }: ApiClient,
    { language: languageCode, zone, showFeature, isUnifiedSite }: AppConfig,
  ) =>
  () =>
  (next: (action: Action) => void) =>
  (action: Action) => {
    const { type } = action;

    if (type === ProfileActions.PROFILE_RENDERED) {
      const { unconfirmedRoles } = getUnconfirmedRolesFromCache(
        apolloClient,
        showFeature('resume-parsing'),
      );

      const { unconfirmedQualifications } =
        getUnconfirmedQualificationsFromCache({
          apolloClient,
          languageCode,
          zone,
          isUnifiedSite,
        });

      const unconfirmedRolesCount = unconfirmedRoles.length;
      const unconfirmedQualificationsCount = unconfirmedQualifications.length;

      metrics.count('my-profile-rendered', [
        `has-unconfirmed-roles:${unconfirmedRolesCount > 0}`,
      ]);
      metrics.count('my-profile-rendered', [
        `has-unconfirmed-quaalifications:${unconfirmedQualificationsCount > 0}`,
      ]);
      metrics.count(`unconfirmed-roles-impression`, [], unconfirmedRolesCount);
      metrics.count(
        `unconfirmed-qualifications-impression`,
        [],
        unconfirmedQualificationsCount,
      );
    }

    if (type === CreateResumeActions.CREATE_RESUME_RENDERED) {
      metrics.count('create-resume-rendered');
    }

    return next(action);
  };
